<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M9 16.59L13.3302 12L9 7.41L10.3396 6L16 12L10.3396 18L9 16.59Z" fill="currentColor" />
  </svg>
</template>
